import { ReactNode, PropsWithChildren } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";

import { GlobalFooter } from "@/patterns/global-footer/src/index";

import { PricingPageFallback } from "./pricing-page-fallback.tsx";

export interface PricingPageLayoutProps extends PropsWithChildren {
    nav?: ReactNode;
    banner?: ReactNode;
    hero?: ReactNode;
    bgColor?: string;
    hasGlobalFooter?: boolean;
    showFallback?: boolean;
}

export const PricingPageLayout = ({
    nav,
    banner,
    hero,
    bgColor,
    hasGlobalFooter = true,
    showFallback = false,
    children
}: PricingPageLayoutProps) => {
    return (
        <>
            {nav && nav}
            {!showFallback && banner}
            {!showFallback && hero}
            <div
                style={{ background: bgColor }}
                css={pricingPageLayoutOuterCss}
            >
                {showFallback && <PricingPageFallback />}

                {!showFallback && children && (
                    <main css={pricingPageLayoutInnerCss} id="content">
                        {children}
                    </main>
                )}
            </div>
            {hasGlobalFooter && (
                <div css={footerCss}>
                    <GlobalFooter />
                </div>
            )}
        </>
    );
};

const footerCss = css({
    marginBlockStart: "64px",
    [media.below.sm]: {
        marginBlockStart: "48px"
    }
});

const pricingPageLayoutOuterCss = css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingBlockStart: "64px",
    paddingBlockEnd: "64px",
    [media.below.md]: {
        paddingBlockStart: "48px"
    },
    [media.below.sm]: {
        paddingBlockStart: "32px"
    }
});

const pricingPageLayoutInnerCss = css({
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "center",
    "gap": "64px",
    "maxWidth": "1152px",
    "width": "100% !important",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "& > *:nth-of-type(2)": {
        marginBlockStart: "-16px"
    },
    [media.above.sm]: {
        paddingInlineStart: "30px",
        paddingInlineEnd: "30px"
    },
    [media.below.sm]: {
        "paddingInlineStart": "60px",
        "paddingInlineEnd": "60px",
        "gap": "48px",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "& > *:nth-of-type(2)": {
            marginBlockStart: "-12px"
        }
    },
    [media.below.xs]: {
        paddingInlineStart: "30px",
        paddingInlineEnd: "30px"
    }
});
